import createStyles from "@mui/styles/createStyles";
export const useStyles = (theme) =>
  createStyles({
    avivaLogo: {
      padding: theme.spacing(0.5),
    },
    bgColorDark: {
      backgroundColor: "#ffd900 !important",
    },
    bgColorLight: {
      backgroundColor: "#FFF0F0 !important",
    },
    bomLogo: {
      height: "44px",
      marginTop: "-10px",
    },
    colorDark: {
      color: "#ffd900",
    },
    colorLight: {
      color: "#ffffff",
    },
    containerButton: {
      position: "fixed",
      bottom: theme.spacing(0.5),
      width: "97.6%",
      left: 4,
      right: 4,
      bgcolor: "background.paper",
      py: 2,
      textAlign: "center",
    },
    contentScroller: {
      justifyContent: "center",
      padding: theme.spacing(2, 0),
      height: "466px",
      overflowY: "scroll",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        padding: theme.spacing(2, 0),
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    fullList: {
      width: "auto",
    },
    headerBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#FFF0F0",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        height: theme.spacing(7),
      },
      [theme.breakpoints.up("sm")]: {
        width: "100%",
        height: theme.spacing(7),
      },
      [theme.breakpoints.up("md")]: {
        width: "100%",
        height: theme.spacing(7),
      },
    },
    headerBoxContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      height: "6vh",
    },
    headerText: {
      flexGrow: 1,
      fontWeight: "bold",
      textAlign: "center",
    },
    headerTitle: {
      flexGrow: 1,
      display: "flex",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
        alignItems: "center",
        textAlign: "center",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        alignItems: "center",
        textAlign: "center",
      },
    },
    list: {
      width: 250,
    },
    logo: {
      height: theme.spacing(7),
      padding: theme.spacing(0.5),
    },
    partnerLogo: {
      backgroundColor: "#C90100 ",
      borderRadius: "5px",
      width: "56px",
      height: "32px",
      fontSize: "12px",
      color: "#FFF",
      padding: "4px",
      marginTop: "-8px",
    },
    watchDemo: {
      position: "fixed",
      top: "54%",
      right: 0,
      transform: "translateY(-50%)",
      backgroundColor: "#ffd900",
      padding: theme.spacing(3.5, 0.5),
      borderTopLeftRadius: theme.spacing(1),
      borderBottomLeftRadius: theme.spacing(1),
      display: "flex",
      alignItems: "center",
      gap: 1,
      cursor: "pointer",
      zIndex: 1030,
      boxShadow: 3,
      writingMode: "vertical-rl",
      textOrientation: "mixed",
      borderRadius: "25px 0px 0px 25px",
    },
    watchDemoExpanded: {
      right: "55% !important",
    },
  });
